import React from 'react';
import { Helmet } from 'react-helmet-async';
import LIRC from '../../../components/Global/BannerCard/LIRC/LIRC';
import CyientShowcase from '../../../components/Global/BannerCard/CyientShowcase/CyientShowcase';
import THC from '../../../components/Global/BannerCard/T&HC/THC';
import MakeTheShift from '../../../components/MakeTheShift/MakeTheShift';
import ExpertiseSection3 from '../../../components/Global/BannerCard/ExpertiseSection3/ExpertiseSection3';
import ContactPage from '../../../components/Global/BannerCard/DynamicHeader/ContactPage1';
import Spotlight from '../../../components/Spolight/Spotlight';
import AerospaceAccelerator from '../../../components/Global/BannerCard/AerospaceAccelerator/AerospaceAccelerator';
import PartnerCarousel from '../../../components/Global/BannerCard/PartnerCarousel/PartnerCarousel';

const AutomotiveMobility = () => {
  const canonicalUrl = `${process.env.REACT_APP_BASE_URL}/automotive-mobility`;
  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <>
      <Helmet>
        <html lang="en" />
        <meta charSet="utf-8" />
        <title>Automotive & Connected Mobility | V Adithya Infinity Pvt Ltd</title>
        <meta
          name="description"
          content="Empowering next-gen mobility through advanced automotive solutions. Discover V Adithya Infinity's role in shaping connected mobility, Zinnov Zones leader 2023."
        />
        <meta
          name="keywords"
          content="Connected mobility India, automotive engineering, smart transportation, V Adithya Infinity, EV solutions, autonomous vehicle support, mobility software, Zinnov Zones automotive"
        />
        {isDevelopment ? (
          <meta name="robots" content="noindex, nofollow" />
        ) : (
          <link rel="canonical" href={canonicalUrl} />
        )}

        {/* Open Graph */}
        <meta property="og:title" content="Automotive & Connected Mobility | V Adithya Infinity Pvt Ltd" />
        <meta
          property="og:description"
          content="Leader in Automotive Zinnov Zones 2023. Discover connected mobility, EV, and automotive engineering services by V Adithya Infinity."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta
          property="og:image"
          content="https://www.adithyainfinity.com/assets/images/automotive-banner.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Automotive & Connected Mobility | V Adithya Infinity Pvt Ltd" />
        <meta
          name="twitter:description"
          content="Empowering the future of mobility with EV, automation, and engineering support. Learn more about our automotive expertise."
        />
        <meta
          name="twitter:image"
          content="https://www.adithyainfinity.com/assets/images/automotive-banner.jpg"
        />

        {/* JSON-LD Structured Data: Organization */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "V Adithya Infinity Pvt Ltd",
            url: canonicalUrl,
            logo: "https://www.adithyainfinity.com/assets/images/logo.png",
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+91-9876543210",
              contactType: "Customer Service",
              areaServed: "IN",
              availableLanguage: ["English", "Hindi", "Telugu"]
            },
            sameAs: [
              "https://www.linkedin.com/company/vadithyainfinity",
              "https://www.facebook.com/vadithyainfinity"
            ]
          })}
        </script>

        {/* JSON-LD Structured Data: Service */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            serviceType: "Automotive & Connected Mobility Engineering",
            provider: {
              "@type": "Organization",
              name: "V Adithya Infinity Pvt Ltd",
              url: "https://www.adithyainfinity.com",
              logo: "https://www.adithyainfinity.com/assets/images/logo.png"
            },
            areaServed: {
              "@type": "Country",
              name: "India"
            },
            description:
              "Comprehensive engineering services for the automotive industry including EV support, connected mobility, and intelligent transport systems."
          })}
        </script>
      </Helmet>

      <div>
        <ContactPage
          title="CONNECTED MOBILITY AND CONNECTING LIVES"
          subTitle="Leader in Automotive Zinnov Zones 2023."
          backgroundImage="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw8NDw0NDQ0QDQ0NEBINDQ0NEBANDQ0NFRIWFhURFRUYHSggGBolGxUVITEhJSkrOi4uFx8/OD84Nyg5OisBCgoKDg0NFQ0NFSsZFRkrLS03LSsrKy03Ny0rKystLS03LS0rNy0tLS0tNysrLTc3Ny0tNystKy03Ny0tKy0tK//AABEIAKgBLAMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAAAAQIHA//EACYQAQAABQUAAgMBAQEAAAAAAAADMdHh8AIUQVOSARFRYcGhsSH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOIAKKACoAigApZFsAAC3LJfktyC3Vm/LWTAuJfkr+QU+/8Av8TJrX8/oEVMmZMD7/gnxn/pkwLFyxcAABAARUAAFQBAAAAUURQAMmCiZMyYirbhMmW5BS3Bky3IBbgyZbkFvwJflcmBklyTOTWv5AyS1/jOTWv5/QGSEyZkwW3CZItyZMC3BfgtyX5AQyZkwATJgqGTBT5D5QABABAUAFEVQABRARSwW5BSxk0tyCljJluQLr9pfkyYH2qZMyYC5/iZMyf6ADJmTAsFuTJgWLluUvyCoZMyYAICoAoCIAAAICgAAAoCioAKBbkQWyZMyYKJk1yYFxL8rkwBMmuTAM/xMmuTAEya5MCwmTMmC5JDJmTADJgCAKAAICAACAAoAAAKIKKAClkAUQEUEBbqyoKIAKgAqAAAAgCoAoAAIAAIAIAioDQn2AoCgAgogCgKKgAomTAFQEUTJgKIuTAEyagCAAZMFAAEVEFQFAABPtUQQABftAGkAFAAABRAFEUAD7UFQAVAAABUAAAAQFQAAEAEBU+w+wPtAAAAABfg+EX4BRPgBRBRQEBUFFEEFEFFEEFEFFEEFEAAAAAAQFD7T7A+flFQAAAAAAAAFEAVWVBRFAAAAAAAAAAAAAAAAABAVBAUQAAAAABAURQAAAAAAFQBVZUFEAURfkARQBFAE+AFEAAAEAFQAAAAAAQAAHvs4vTE8aqGzi9MTxqoAGzi9MTxqouzi9MTxqogC7OL1RPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9UTxqogC7OL1RPGqibOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAP/9k="
          highlightWord="CONNECTED MOBILITY"
        />
        <LIRC />
        <CyientShowcase />
        <ExpertiseSection3 />
        <THC />
        <Spotlight />
        <PartnerCarousel />
        <AerospaceAccelerator />
        <MakeTheShift />
      </div>
    </>
  );
};

export default AutomotiveMobility;
